import React from 'react';
import {useMenu} from '../../../hooks/useMenu';
import CommonMenu from '../../menu/commonMenu';
import styles from './full-body.module.css';

function FullBodyMenu({...props}) {
  const {menuList} = styles;

  return (
    <div className={menuList}>
      <CommonMenu {...props} />
    </div>
  );
}

export default FullBodyMenu;
